import { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Skeleton, Tabs, Typography } from "antd";
import { useGetBotQuery } from "api";
import { useAppSelector } from "store/hooks";
import { getRouteByName } from "libs";
import { BotInfoTab } from "./BotInfoTab";
import { BotTasksTab } from "./BotTasksTab";
import { BotStatsTab } from "./BotStatsTab";
import { BotActivityTab } from "./BotActivityTab";

const DEFAULT_TAB = "#info";

export const BotPage = () => {
  const { botId } = useParams();
  const numericId = Number(botId);

  const { hash, pathname } = useLocation();
  const navigate = useNavigate();

  const { isAll, isBotsRead } = useAppSelector(
    (state) => state.loggedAdmin.parsedPermissions
  );

  const { data: bot, isLoading } = useGetBotQuery(
    { id: numericId },
    { skip: !numericId }
  );

  useEffect(() => {
    if (!isAll && !isBotsRead) {
      navigate(getRouteByName("NotFoundPage"));
    }
  }, [isAll, isBotsRead, navigate]);

  const items = useMemo(
    () => [
      {
        label: "Informatii",
        key: "#info",
        children: bot ? <BotInfoTab bot={bot} /> : null,
      },
      {
        label: "Sarcini",
        key: "#tasks",
        children: bot ? <BotTasksTab botId={bot.id} /> : null,
      },
      {
        label: "Statistici",
        key: "#stats",
        children: bot ? <BotStatsTab botId={bot.id} /> : null,
      },
      {
        label: "Activitate",
        key: "#activity",
        children: bot ? <BotActivityTab botId={bot.id} /> : null,
      },
    ],
    [bot]
  );

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 10 }} />;
  }

  if (!bot) {
    return <Typography.Text type="danger">Botul nu a fost gasit.</Typography.Text>;
  }

  return (
    <>
      <Typography.Title level={3} style={{ margin: "0 0 16px 0" }}>
        {bot.name}
      </Typography.Title>
      <Tabs
        items={items}
        activeKey={hash || DEFAULT_TAB}
        onChange={(val) => navigate({ pathname, hash: val })}
        destroyInactiveTabPane
      />
    </>
  );
};
